let isHoverActive = false;
export default () => {
    const header = document.querySelector('.header');
    if(!header) return;

    initializeHeaderSlider();
    initializeHoverEffect();
    initializeHeaderNavMobile();

    window.onscroll = () => {
        if(header.classList.contains('header--lock-scrolled')) return;
        if(isHoverActive) return;
        if(window.pageYOffset > 0) {
            header.classList.add('header--scrolled');
        } else {
            header.classList.remove('header--scrolled');
        }
    };
}

const initializeHeaderSlider = () => {
    const headerSlider = document.querySelector('.header__slider .splide');
    if(!headerSlider) return;

    const splide = new window.splide(headerSlider, {
        type: 'loop',
        perPage: 1,
        rewind: true,
        arrows: true,
        noDrag: 'p, a',
        pagination: false
    });

    splide.on( 'overflow', function ( isOverflow ) {
        splide.options = {
            arrows: isOverflow,
            drag: isOverflow,
        };
    });

    splide.mount();
}

const initializeHoverEffect = () => {
    const header = document.querySelector('.header');
    if(!header) return;
    const headerOverlay = document.querySelector('.header__overlay');
    const hoverElements = document.querySelectorAll('.header__nav > ul > li.menu-item-has-children');
    if(!hoverElements) return;

    hoverElements.forEach(hoverElement => {
        hoverElement.addEventListener('mouseenter', () => {
            headerOverlay.classList.add('active');
            header.classList.add('header--scrolled');
            isHoverActive = true;
        });
        hoverElement.addEventListener('mouseleave', () => {
            headerOverlay.classList.remove('active');
            if(window.pageYOffset === 0 && window.innerWidth > 1100 && !header.classList.contains('header--lock-scrolled')) header.classList.remove('header--scrolled');
            isHoverActive = false;
        });
    })
}

const initializeHeaderNavMobile = () => {
    const header = document.querySelector('.header');
    if(!header) return;
    const headerNav = document.querySelector('.header__nav');
    const opener = document.querySelector('.header__opener');
    if (!headerNav || !opener) return;

    opener.addEventListener('click', () => {
        headerNav.classList.toggle('header__nav--active');
        document.body.classList.toggle('body--no-scroll');
        if(!header.classList.contains('header--lock-scrolled') && window.pageYOffset === 0) header.classList.toggle('header--scrolled');
    })

    const submenuTriggers = headerNav.querySelectorAll(':scope > ul > li.menu-item-has-children > a');
    if(!submenuTriggers) return;
    submenuTriggers.forEach(submenuTrigger => {
        submenuTrigger.addEventListener('click', e => {
            e.preventDefault();
            const submenu = submenuTrigger.parentNode.querySelector(':scope > .submenu-wrapper');
            submenu.classList.add('opened');
        })
    })

    const mobileSubmenuNavs = headerNav.querySelectorAll('.submenu-mobile-nav');
    if(!mobileSubmenuNavs) return;
    mobileSubmenuNavs.forEach(mobileSubmenuNav => {
        const hideButton = mobileSubmenuNav.querySelector('svg');
        if(!hideButton) return;
        hideButton.addEventListener('click', () => {
            mobileSubmenuNav.parentNode.classList.remove('opened');
        })
    })
}